<template>
    <div>
        <div v-if="bauherrFilter.length && fb.length">
            <table>
                <tbody>
                    <tr class="table-head">
                        <th scope="row">Bauherr</th>
                        <th scope="row">Bauvorhaben</th>
                        <th scope="row">Adresse</th>
                        <th class="row" scope="row">Auftraggeber</th>
                        <th class="highlight">Beginn &darr;</th>
                        <th class="row"><span class="material-icons alert">info</span></th>
                        <th class="row">Details</th>
                    </tr>
                    <tr v-for="(baustelle, index) in fb" v-bind:key="index">
                        <td>{{ baustelle.bauherr}}</td>
                        <td>{{ baustelle.bvh}}</td>
                        <td>{{ baustelle.adresse}}</td>
                        <td>{{ baustelle.auftraggeber}}</td>
                        <td>{{ baustelle.beginn | formatStrDate}}</td>
                         <td>
                          <div v-if="baustelle.alert"><span class="material-icons alert">info</span></div>
                        </td>
                        <td class="button-col">
                          <router-link
                            class="button arrow-button"
                            :to="{ name: 'Detail', params: { id: baustelle.id }}">
                              <span class="material-icons">arrow_forward</span>
                          </router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-else>
            <table v-if="filterBeginn.length">
                <tbody>
                    <tr class="table-head">
                        <th scope="row">Bauherr</th>
                        <th scope="row">Bauvorhaben</th>
                        <th scope="row">Adresse</th>
                        <th class="row" scope="row">Auftraggeber</th>
                        <th class="highlight">Beginn &darr;</th>
                        <th class="row"><span class="material-icons alert">info</span></th>
                        <th class="row">Details</th>
                    </tr>
                    <tr v-for="(baustelle, index) in filterBeginn" v-bind:key="index">
                        <td>{{ baustelle.bauherr}}</td>
                        <td>{{ baustelle.bvh}}</td>
                        <td>{{ baustelle.adresse}}</td>
                        <td>{{ baustelle.auftraggeber}}</td>
                        <td>{{ baustelle.beginn | formatStrDate}}</td>
                        <td>
                          <div v-if="baustelle.alert"><span class="material-icons alert">info</span></div>
                        </td>
                        <td><router-link class="button" :to="{ name: 'Detail', params: { id: baustelle.id }}">Details</router-link></td>
                    </tr>
                </tbody>
            </table>
        </div>
    
    </div>  
</template>

<script>
import moment from "moment";

export default {
  props: ["filterBeginn", "bauherrFilter"],
  filters: {
    formatStrDate(date) {
      return moment(date).format("DD.MM.YYYY");
    }
  },
  computed: {
    fb: function() {
      let inp = this.bauherrFilter.toLowerCase();
      return this.filterBeginn.filter(obj => {
        return Object.keys(obj).some(
          key =>
            typeof obj[key] === "string" && obj[key].toLowerCase().includes(inp)
        );
      });
    },
  }
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  margin-top: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
  font-size: 12px;
}

.table-head {
  background: #2c3e50;
  color: #eeeeee;
  font-size: 14px;
}

td,
th {
  border-right: 1px solid rgb(212, 212, 212);
  padding: 0.5rem;
}

td:last-of-type,
th:last-of-type {
  border-right: none;
}

tr {
  height: 40px;
}

tr:nth-child(even) {
  background: #e3e3e4;
}

.button-col {
  text-align: center;
}

tfoot td {
  border: none;
  background: white;
  padding-left: 0;
}

.highlight {
  color: #2c3e50;
  background-color: #eeeeee;
  white-space: nowrap;
}

.material-icons {
  vertical-align: middle;
  font-size: 20px;
}

.arrow-button {
  padding: 5px;
  border-radius: 100px;
  font-size: 15px;
}

.alert {
  border-radius: 100px;
  font-size: 22px;
}
</style>
